import React, { useRef } from 'react'
import MenuBar from '../../components/MenuBar'
import Header from '../../components/Header'
import './CreateRentalContractPage.css'
import httpClient from '../../components/helpers/httpClient'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { RentalContractForm } from './RentalContractForm.jsx'
import Button from '../../components/UI/Button'

function CreateRentalContractPage() {
  const navigate = useNavigate()
  const formRef = useRef()

  const handleSave = async () => {
    await formRef.current?.submit()
  }

  return (
    <div className='template'>
      <Header>
        <div className="header__filters">
          <Button variant='primary' size='sm' onClick={handleSave}>Save</Button>
        </div>
      </Header>
      <MenuBar />

      <div className='template__body' id='body-create-rental-contract'>
        <div className='body__section'>
          <RentalContractForm
            ref={formRef}
            initialData={null}
            readOnly={false}
            onSubmit={async (payload) => {
              try {
                const response = await httpClient.post(import.meta.env.VITE_API_URL + `/api/rental-contracts`, payload)
                if (response.status === 200) {
                  toast.success('Rental contract created')
                  navigate('/rental-contracts')
                } else {
                  toast.error('Failed to create contract')
                }
              } catch (e) {
                toast.error('Failed to create contract')
              }
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default CreateRentalContractPage


